import { Action } from 'helpers/action-helpers';
import { ColDef } from 'ag-grid';
import { GridLayoutType } from './state';

export const SELECT_ROW = 'SelectRowAction';
export const EDIT_ROW = 'EditRowAction';
export const DELETE_ROWS = 'DeleteRowsAction';
export const SET_ROWS = 'SetRowsAction';
export const LIST_ROWS = 'ListRowsAction';
export const SET_COLUMNS = 'SetColumnsAction';

export class SelectRowAction extends Action {
  constructor(public rowId: string) {
    super(SELECT_ROW);
  }
}

export class EditRowAction extends Action {
  constructor(public rowId: string) {
    super(EDIT_ROW);
  }
}

export class DeleteRowsAction extends Action {
  constructor(public rowId: string) {
    super(DELETE_ROWS);
  }
}

export class SetRowsAction extends Action {
  constructor(public rows: object[]) {
    super(SET_ROWS);
  }
}

export class ListRowsAction extends Action {
  constructor() {
    super(LIST_ROWS);
  }
}

export class SetColumnsAction extends Action {
  constructor(public gridLayoutType: GridLayoutType,
    public columns: ColDef[]) {
    super(SET_COLUMNS);
  }
}


// WEBPACK FOOTER //
// ./src/components/user-grid/actions.ts